import { BlockModel } from '@blocksuite/store';

import type { EmbedCardStyle } from '../../../utils/index.js';
import { defineEmbedModel } from '../../../utils/index.js';

export type EmbedVideoBlockUrlData = {
  videoId: string | null;
  image: string | null;
  title: string | null;
  description: string | null;
  creator: string | null;
  creatorUrl: string | null;
  creatorImage: string | null;
  aspectRatio: string | null;
  poster: string | null;
};

export const EmbedVideoStyles = ['video'] as const satisfies EmbedCardStyle[];

export type EmbedVideoBlockProps = {
  style: (typeof EmbedVideoStyles)[number];
  url: string;
  caption: string | null;
} & EmbedVideoBlockUrlData;

export class EmbedVideoModel extends defineEmbedModel<EmbedVideoBlockProps>(
  BlockModel
) {}
